import api from './Api';
import {
  IClienteAcessoAuditoria,
  IClienteAcessoAuditoriaRequest,
  IClienteGerarApiChaveResponse,
} from '../interfaces/IClienteAcessoAuditoria';

const ClienteAcessoAuditoriaService = {
  getAcesso: (clienteId: number): Promise<{ data: IClienteAcessoAuditoria }> =>
    api.get(`/cliente/${clienteId}/acesso-auditoria`),

  setStatus: (
    clienteId: number,
    dto: IClienteAcessoAuditoriaRequest
  ): Promise<{ data: IClienteAcessoAuditoria }> =>
    api.put(`/cliente/${clienteId}/acesso-auditoria`, dto),

  liberarTrial: (clienteId: number): Promise<{ data: IClienteAcessoAuditoria }> =>
    api.post(`/cliente/${clienteId}/acesso-auditoria/liberar-trial`),

  gerarApiKey: (clienteId: number): Promise<{ data: IClienteGerarApiChaveResponse }> =>
    api.post(`/cliente/${clienteId}/acesso-auditoria/gerar-api-key`),
};

export default ClienteAcessoAuditoriaService;
